import { render, staticRenderFns } from "./SnippetList.vue?vue&type=template&id=bac58d5e&"
import script from "./SnippetList.vue?vue&type=script&lang=js&"
export * from "./SnippetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports